import React from "react";
import {
  StyledProgressBar,
  StyledProgressBarCaption,
  StyledProgressBarFiller,
} from "../../dashboard.style";
const NoStatsProgressBar = ({ sessionsAnalyzed }) => {
  const sessionsLeft = sessionsAnalyzed < 500 ? 500 - sessionsAnalyzed : 0;
  const fillProgressBar = ((500 - sessionsLeft) * 100) / 500;
  return (
    <div>
      <StyledProgressBar>
        <StyledProgressBarFiller value={fillProgressBar} />
      </StyledProgressBar>
      <StyledProgressBarCaption>
        <p>{sessionsAnalyzed} Sessions Analyzed</p>
        <p>{sessionsLeft} Sessions Left</p>
      </StyledProgressBarCaption>
    </div>
  );
};
export default NoStatsProgressBar;
